import { CurrentUser, DeviceMeta, Dialog, SharedElementManipulator, BootstrapWidgets } from "Roblox";
import angular from "angular";
import catalogModule from '../catalogModule';

function catalogController($timeout, $location, $http, $log, $scope, $anchorScroll, abpService, catalogService,
    catalogConstants, constantsService, languageResource, utilityService, thumbnailService, metricsService) {
    "ngInject";

    $scope.splashTiles = [];
    $scope.showSplashTiles = true;
    $scope.currentUserId = CurrentUser ? CurrentUser.userId : null;

    $scope.$on('$locationChangeSuccess', function () {
        utilityService.setFiltersForCommunityCreations($scope.data);
        if (!$scope.layout.initialized) {
            return;
        }

        if ($scope.layout.preventLocationChange) {
            $scope.layout.preventLocationChange = false;
            return;
        }

        if ($scope.navigationMenu.filtersInitialized) {
            $scope.setSelectedFilters();
        }

        if ($scope.queries && !$scope.queries.category) {
            const { category, subcategory } = $scope.currentQuery;
            $scope.queries.category = category && category.categoryId;
            $scope.queries.subcategory = subcategory && subcategory.subcategoryId;
        }

        $scope.expandSelectedCategoryMenu();

        if (!$scope.library.isSplashPage) {
            $scope.getPagedItems(true);
            $scope.adRefresh();
        }
    });

    $scope.setupAds = function () {
        if (!$scope.layout.adsInitialized) {
            $scope.layout.adsInitialized = true;
            abpService.registerAd(abpService.adIds.leaderboardAbp);
        }
    }

    $scope.adRefresh = function () {
        abpService.refreshAllAds();
    }

    $scope.setupLibrary = function () {
        $scope.library = {};
        const libraryData = {
            isPhone: DeviceMeta().isPhone,
            isDesktop: DeviceMeta().isDesktop,
            isApp: DeviceMeta().isInApp,
            buyRobuxUrl: catalogConstants.buyRobuxUrl,
            catalogUrl: catalogConstants.catalogUrl,
            isSplashPage: utilityService.isSplashPage()
        }
        $scope.library = Object.assign({}, libraryData);
    }

    $scope.checkIfFullScreen = function () {
        const isFullScreen = angular.element("#container-main").hasClass("full-screen");
        $scope.library.isFullScreen = isFullScreen;
    }

    $scope.initialize = function () {
        if ($scope.layout && $scope.layout.initialized) {
            return;
        }
        $scope.forms = {};
        $scope.data = {}; // sunsetting, please do not add more data into this object
        $scope.navigationMenu = {};
        $scope.searchResultDict = {}; // store catalog items, bundle items...
        $scope.searchResultList = []; // keep the order
        $scope.paginations = Object.assign({}, catalogConstants.initializedPaginations);
        $scope.searchLayout = {
            keyword: null,
            keywordForDisplay: null
        }
        $scope.queries = {}; // params for search
        $scope.currentQuery = {}; // story current category and subcategory
        $scope.layout = angular.copy(catalogConstants.layout);

        utilityService.setFiltersForCommunityCreations($scope.data);

        $scope.setupLibrary();
        $scope.checkIfFullScreen();
        $scope.getMetadataFromApi();
        $scope.setupAds();
    }

    $scope.checkEnrollment = function () {
        catalogService.checkEnrollment()
            .then(function success(result) {
                const { data } = result;
                if (data) {
                    const { variations, status } = catalogConstants.abTestingParams;
                    data.forEach(function (enrollment) {
                        const { Variation, Status } = enrollment;
                        if (Status === status.enrolled) {
                            $scope.library.isFullScreenEnabledFromAbTesting = Variation === variations.fullScreenCatalogVariation;
                        }
                    });
                }

                $scope.getPagedItems(true, true);
            });
    }

    $scope.getMetadataFromApi = function () {
        catalogService.getMetadataFromApi()
            .then(function success(result) {
                // TODO: PLEASE DO NOT ADD UNDER $SCOPE.DATA, USE $SCOPE.LIBRARY PLEASE
                $scope.data.isNewCatalogLayoutEnabled = result.isNewCatalogLayoutEnabled;
                $scope.data.isCatalogInfiniteScrollEnabled = result.isCatalogInfiniteScrollEnabledForAll;
                $scope.data.isCatalogFavoritesLinkEnabled = result.isCatalogFavoritesLinkEnabledForAll;
                $scope.data.newCatalogLayoutAbTestName = result.newCatalogLayoutAbTestName;
                // TODO: PLEASE DO NOT ADD UNDER $SCOPE.DATA, USE $SCOPE.LIBRARY PLEASE

                const {
                    numberOfCatalogItemsToDisplayOnSplashOnPhone,
                    numberOfCatalogItemsToDisplayOnSplash,
                    isCatalogInfiniteScrollEnabledForAll,
                    isGoogleAnalyticsEventForAjaxFailureEnabled,
                    isFloodCheckErrorLogEnabled
                } = result;
                const libraryData = {
                    numberOfSplashResultsToDisplay: $scope.library.isPhone ? numberOfCatalogItemsToDisplayOnSplashOnPhone : numberOfCatalogItemsToDisplayOnSplash,
                    initialized: true,
                    isCatalogInfiniteScrollEnabledForAll: isCatalogInfiniteScrollEnabledForAll,
                    isGoogleAnalyticsEventForAjaxFailureEnabled: isGoogleAnalyticsEventForAjaxFailureEnabled,
                    isFloodCheckErrorLogEnabled: isFloodCheckErrorLogEnabled
                }
                Object.assign($scope.library, libraryData);

                $scope.getSearchOptions();
            }, function error() {
                const { defaultMetadata } = catalogConstants;
                $scope.library.numberOfSplashResultsToDisplay = $scope.library.isPhone ? defaultMetadata.numberOfCatalogItemsToDisplayOnSplash : defaultMetadata.numberOfCatalogItemsToDisplayOnSplashOnPhone;
                $scope.library.initialized = true;
                $scope.getSearchOptions();
            });
    }

    $scope.callBackForSearchOptions = function () {
        $scope.setSelectedFilters();
        $scope.displayAddGearModal();
        $scope.setQuery(true);
        $scope.getPagedItems(true, true);
        // This is to ensure the external libraries are called to setup the menus after angular has finished rendering
        var waitForRenderAndSetupMenus = function () {
            if ($http.pendingRequests.length > 0) {
                $timeout(waitForRenderAndSetupMenus);
            } else {
                $scope.expandSelectedCategoryMenu();
                $scope.layout.resetVerticalMenu = true;
            }
        }

        $timeout(waitForRenderAndSetupMenus);
    }

    $scope.getSearchOptions = function () {
        $scope.layout.hasSearchOptionsError = false;

        catalogService.getNavigationMenuItems()
            .then(function success(result) {
                utilityService.buildNavigationMenu(result, $scope.library);

                $scope.setNavigationMenu(result);
                $scope.callBackForSearchOptions();
            }).finally(function () {
                $scope.layout.isNavigationMenuLoaded = true;
            });
    }

    $scope.resetPaginations = function () {
        Object.assign($scope.paginations, catalogConstants.initializedPaginations);
    } 

    $scope.resetPageContentAndLoading = function (clearResults) {
        $scope.layout.showNoResultsMessage = false;
        $scope.layout.showErrorMessage = false;
        $scope.layout.loading = false;

        $scope.layout.isItemDetailsLoaded = false;
        $scope.layout.isAssetThumbnailLoaded = false;
        $scope.layout.isBundleThumbnailLoaded = false;

        $scope.layout.isItemDetailsLoadingFailed = false;

        if(clearResults)
        {
            $scope.searchResultDict = {};
            $scope.searchResultList = [];

            if (!$scope.paginations.startPaging) {
                $scope.resetPaginations();
            }
        }
    }

    $scope.setPaginations = function (searchResult) {
        if ($scope.showViewAllFeaturedItemsButton()) {
            return false;
        } 
        let isPaginationEnabled = true;
        if ($scope.library.isPhone) {
            isPaginationEnabled = false; // pagination window is disabled when in phone or all featured page
        }

        const { previousPageCursor, nextPageCursor } = searchResult;
        Object.assign($scope.paginations, { previousPageCursor, nextPageCursor });
        const { currentPage } = $scope.paginations;
        if ($scope.paginations.direction === catalogConstants.pageDirection.next) {
            $scope.paginations.currentPage++;
        } else if ($scope.paginations.direction === catalogConstants.pageDirection.prev) {
            $scope.paginations.currentPage = currentPage > 0 ? currentPage - 1 : 0;
        } else {
            isPaginationEnabled = nextPageCursor || previousPageCursor; 
        }

        $scope.paginations.isEnabled = isPaginationEnabled;
    }

    $scope.buildSeachResultData = function (data) {
        if (!data || data.length === 0) {
            $scope.layout.showNoResultsMessage = true;
            return false;
        }

        const { itemTypes, thumbnailsParams } = catalogConstants;
        let bundleIdsMapKey = {}, itemParamsMapKey = {}, catalogParamsMapKey = {};
        data.forEach(function (item) {
            const key = utilityService.getCatalogContentKey(item);
            item.key = key;
            $scope.searchResultDict[key] = item;
            if ($scope.searchResultList.indexOf(key) < 0) {
                $scope.searchResultList.push(key);
            }

            const itemId = item.id;
            if (item && item.itemType === itemTypes.bundle) {
                bundleIdsMapKey[itemId] = item;
            } else {
                catalogParamsMapKey[itemId] = item;
            }
            itemParamsMapKey[itemId] = item;
        });

        catalogService.getCatalogItemDetails(itemParamsMapKey)
                                .then(function success(details) {
                                    utilityService.updateSearchItemDetails(details, $scope.searchResultDict);
                                    }, function error(result) {
                                        const { isGoogleAnalyticsEventForAjaxFailureEnabled, isFloodCheckErrorLogEnabled } = $scope.library;
                                        const { endpointNames } = catalogConstants.errorMessages;
                                        if (isGoogleAnalyticsEventForAjaxFailureEnabled) {
                                            metricsService.sendErrorsToGoogleAnalytics(result, endpointNames.getCatalogItemDetails);
                                        }

                                        if (isFloodCheckErrorLogEnabled) {
                                            metricsService.sendErrorsToLogCount(result, endpointNames.getCatalogItemDetails);
                                        }
                                    $scope.layout.isItemDetailsLoadingFailed = true;
                                }).finally(function () {
                                    $scope.layout.isItemDetailsLoaded = true;
                                });
        const itemThumbnailParams = {
            size: thumbnailsParams.size.md
        };
        if (Object.keys(catalogParamsMapKey).length > 0) {
            thumbnailService.getItemThumbnails(itemTypes.asset, catalogParamsMapKey, itemThumbnailParams)
                .then(function success(thumbnails) {
                    utilityService.updateSearchItemThumbnails(thumbnails, $scope.searchResultDict);
                }, function error() {
                }).finally(function () {
                    $timeout(function () {
                        $scope.layout.isAssetThumbnailLoaded = true;
                    }, 500);
                });

        }
        if (Object.keys(bundleIdsMapKey).length > 0) {
            thumbnailService.getItemThumbnails(itemTypes.bundle, bundleIdsMapKey, itemThumbnailParams)
                .then(function success(thumbnails) {
                    utilityService.updateSearchItemThumbnails(thumbnails, $scope.searchResultDict);
                }, function error() {
                }).finally(function () {
                    $timeout(function () {
                        $scope.layout.isBundleThumbnailLoaded = true;
                    }, 500);
                });
        }
    }

    $scope.getSearchItems = function (params, clearResults) {
        utilityService.translateToEnumStrings($scope.library, params);
        catalogService.getSearchItems(params, $scope.library.isFullScreen)
            .then(function success(searchResult) {
                $scope.resetPageContentAndLoading(clearResults);
                if (searchResult) {
                    const { data, keyword } = searchResult;
                    $scope.searchLayout.keyword = keyword;
                    $scope.searchLayout.keywordForDisplay = keyword;

                    $scope.setPaginations(searchResult);
                    $scope.buildSeachResultData(data);
                }
            }, function (result) {
                $log.debug(" ------ getCatalogResults error -------");
                $scope.resetPageContentAndLoading(clearResults);
                $scope.layout.showErrorMessage = true;
                $scope.resetPageContentAndLoading(clearResults);
                
                const { endpointNames } = catalogConstants.errorMessages;
                const { isGoogleAnalyticsEventForAjaxFailureEnabled, isFloodCheckErrorLogEnabled } = $scope.library;
                if (isGoogleAnalyticsEventForAjaxFailureEnabled) {
                    metricsService.sendErrorsToGoogleAnalytics(result, endpointNames.getSearchItems);
                }

                if (isFloodCheckErrorLogEnabled) {
                    metricsService.sendErrorsToLogCount(result, endpointNames.getSearchItems);
                }
            }).finally(function () {
                if (!$scope.layout.initialized) {
                    $scope.layout.initialized = true;
                }
                $scope.paginations.startPaging = false;
                $scope.layout.isSearchItemsLoaded = true;
            });
    }

    $scope.getPagedItems = function (clearResults, fadeResultsWhileLoading) {
        if (clearResults && !fadeResultsWhileLoading) {
            $scope.searchResultDict = {};
            $scope.searchResultList = [];
        }
        $scope.layout.loading = true;
        $scope.getSearchItems($scope.queries, clearResults);
    }

    $scope.displayAddGearModal = function () {
        // display "Add Gear to Game" instructions modal if the relevant query parameter exists
        var query = utilityService.getQueriesValueIntoInt();
        if (query && query.showInstructions) {
            Dialog.open({
                titleText: constantsService.addGearToGameModal.title,
                bodyContent: constantsService.addGearToGameModal.bodyContent,
                allowHtmlContentInBody: true,
                imageUrl: $scope.library.addGearImageUrl,
                declineText: constantsService.addGearToGameModal.declineText,
                showAccept: false,
                xToCancel: true,
                cssClass: constantsService.addGearToGameModal.cssClass
            });
        }
    }

    $scope.setNavigationMenu = function (data) {
        const { priceFilters, categories, genres, sortMenu, creatorFilters } = data;
        const navigationMenu = {
            categories: categories,
            currencyTypes: priceFilters,
            genres: genres,
            sortMenus: sortMenu
        }
        Object.assign($scope.navigationMenu, navigationMenu);

        $scope.setCreatorFilters(creatorFilters);
        $scope.navigationMenu.filtersInitialized = true;

        $scope.navigationMenu.categories.forEach(function (catagory) {
            // for now, only apply such sorting to subcategories of "Gear"
            if (catagory.categoryId === $scope.library.gearCategoryId) {
                catagory.subcategories.sort($scope.gearSubcategoryCompare);
            }
        });


        if (priceFilters && priceFilters.length > 0) {
            $scope.library.defaultCurrencyType = priceFilters[0];
        }

        // for transition to catalog api, pass back to old object
        Object.assign($scope.data, $scope.navigationMenu);
    }

    // compare subcategories of "Gear"
    $scope.gearSubcategoryCompare = function (leftSubcategory, rightSubcategory) {
        // check to pin "All Gear" to the top
        if (leftSubcategory.subcategoryId === catalogConstants.allGearSubcategoryId) {
            return -1;
        }

        if (rightSubcategory.subcategoryId === catalogConstants.allGearSubcategoryId) {
            return 1;
        }

        return languageResource.intl.langSensitiveCompare(leftSubcategory.name, rightSubcategory.name);
    }

    $scope.setSelectedFilters = function () {
        var query = utilityService.getQueriesValueIntoInt();

        $scope.data.query = query;
        $scope.queries = utilityService.formatQueries(query);
        $scope.searchLayout.keyword = query.Keyword;
        $scope.searchLayout.keywordForDisaply = query.Keyword;
        $scope.setSelectedNavigationMenu(query.Category, query.Subcategory, query.Gears, query.CatalogContext);
        $scope.setCreatorValue(query.CreatorID, query.CreatorName, query.CreatorType);
        $scope.setCurrencyValue(query.CurrencyType, query.pxMin, query.pxMax);
        $scope.data.includeNotForSale = query.IncludeNotForSale || false;
        $scope.setGenresInMenuOptions(query.Genres);
        $scope.setSortMenus(query.SortType, query.SortAggregation);
    }

    $scope.setSearchOptionsOpenValue = function (value) {
        $scope.layout.isSearchOptionsOpen = value;
        $scope.layout.hideMainView = value;
        SharedElementManipulator.toggleChat(value);
        SharedElementManipulator.toggleFooter(value);
        SharedElementManipulator.togglePagification(value);

        if (!value) {
            $anchorScroll(); // scroll to top of page
        }
    }

    $scope.toggleSearchOptions = function (open) {
        $scope.setSearchOptionsOpenValue(open);

        // if canceling changes to mobile search options, reset all filter selections
        if (!open) {
            $scope.setSelectedFilters();
            $scope.closeWarning();
        }
    }

    $scope.onKeywordKeypress = function (event, fadeResultsWhileLoading) {
        // if user hits Enter, perform search
        if (event.which === 13) {
            event.target.blur();
            $scope.searchKeyword(fadeResultsWhileLoading);
        }
    }

    $scope.searchKeyword = function (fadeResultsWhileLoading) {
        $scope.applySearch(fadeResultsWhileLoading);
    }

    $scope.applyMobileSearch = function () {
        if ($scope.forms.searchOptionsForm && !$scope.forms.searchOptionsForm.$valid) {
            $scope.layout.showError = true;
            return;
        }

        $scope.setSearchOptionsOpenValue(false);
        $scope.closeWarning();
        $scope.library.isSplashPage = false;
        $scope.applySearch();
    }

    $scope.closeWarning = function () {
        $scope.layout.showError = false;
    }

    $scope.fetchNextFromInfiniteScroll = function () {
        if ($scope.layout.isSearchOptionsOpen
            || $scope.layout.loading
            || !$scope.paginations.nextPageCursor) {
            return;
        }

        if ($scope.library.isSplashPage) {
            $scope.library.isSplashPage = false;
            $scope.queries.category = $scope.currentQuery.category && $scope.currentQuery.category.categoryId;
            $scope.queries.subcategory = $scope.currentQuery.subcategory && $scope.currentQuery.subcategory.subcategoryId;
        }

        $scope.queries.cursor = $scope.paginations.nextPageCursor;
        $scope.getSearchItems($scope.queries);
        $scope.paginations.direction = catalogConstants.pageDirection.next;
    }

    $scope.setQuery = function (rememberPage) {
        var params = {};

        $scope.setKeywordParam(params);
        $scope.setCategoryParams(params);
        $scope.setGenresForMenuOptions(params);
        $scope.setCreatorParam(params);
        $scope.setPriceParams(params);

        if ($scope.data.sortType != null && $scope.data.sortType.sortType !== $scope.library.defaultSortTypeId) {
            params.SortType = $scope.data.sortType.sortType;
        }

        if ($scope.data.sortType != null && $scope.data.sortType.hasSubMenu
            && $scope.data.sortAggregation != null && $scope.data.sortAggregation !== $scope.library.defaultSortAggregationId) {
            params.SortAggregation = $scope.data.sortAggregation.sortAggregation;
        }

        if ($scope.data.includeNotForSale) {
            params.IncludeNotForSale = $scope.data.includeNotForSale;
        }

        $scope.data.query = params;
        $scope.queries = utilityService.formatQueries(params);
        $scope.layout.preventLocationChange = true;
        $location.search(params);
    }

    $scope.setKeywordParam = function (params) {
        const { keyword } = $scope.searchLayout;
        $scope.searchLayout.keywordForDisplay = null;
        if (keyword) {
            params.Keyword = keyword;
            $scope.searchLayout.keywordForDisplay = keyword;
        }
    }

    $scope.setCategoryParams = function (params) {
        if ($scope.currentQuery.category && (!$scope.library.displaySplash || $scope.paginations.currentPage > 1)) {
            params.Category = $scope.currentQuery.category.categoryId;

            if ($scope.currentQuery.subcategory != null) {
                if ($scope.currentQuery.category.categoryId === $scope.library.gearCategoryId) { //TODO: could remove this after rollout
                    // if gear subcategory is the default, don't set it
                    if ($scope.currentQuery.subcategory.subcategoryId !== catalogConstants.defaults.subcategory) {
                        params.Gears = $scope.currentQuery.subcategory.subcategoryId;
                        params.Subcategory = $scope.currentQuery.subcategory.subcategoryId;
                    }
                }
                else {
                    params.Subcategory = $scope.currentQuery.subcategory.subcategoryId;
                }
            }
        }
    }

    $scope.setGenresForMenuOptions = function (params) {
        var genreInts = [];
        const { genres } = $scope.navigationMenu;
        if (genres) {
            for (var i = 0; i < genres.length; i++) {
                var genre = genres[i];
                if (genre.isSelected) {
                    genreInts.push(genre.genre);
                }
            }
        }

        if (genreInts.length > 0) {
            params.Genres = genreInts;
        }
    }

    $scope.setCreatorParam = function (params) {
        $scope.data.creatorBreadcrumb = null;
        $scope.data.displayCreators = $scope.currentQuery.category && $scope.library.categoriesWithCreatorFilters.includes($scope.currentQuery.category.categoryId);

        // only add CreatorID if the selected ID is Roblox (1)
        if ($scope.data.displayCreators && $scope.data.creator
            && $scope.data.creator.userId !== $scope.library.defaultCreatorId) {
            if ($scope.data.creator.userId === $scope.library.robloxUserId) {
                params.CreatorID = $scope.data.creator.userId;
                $scope.data.creatorBreadcrumb = $scope.data.creator.name;
            } else if ($scope.data.creator.userId === $scope.layout.customText && $scope.data.creatorName != null) {
                params.CreatorName = $scope.data.creatorName;
                $scope.data.creatorBreadcrumb = $scope.data.creatorName;
            } else if ($scope.data.creator.userId) {
                params.CreatorID = $scope.data.creator.userId;
            }
        }

        if ($scope.data.creator && $scope.data.creator.type) {
            params.CreatorType = $scope.data.creator.type;
        }
    };

    $scope.setPriceParams = function (params) {
        const { currencyType } = $scope.data;
        $scope.data.showFreeBreadcrumb = currencyType && currencyType.currencyType === $scope.library.freeFilterId;
        $scope.data.minPriceBreadcrumb = null;
        $scope.data.maxPriceBreadcrumb = null;
        if (currencyType != null && currencyType.currencyType !== $scope.library.defaultCurrencyId) {
            params.CurrencyType = currencyType.currencyType;

            // if currencyType is Custom Robux, set min and max values
            if (currencyType.currencyType === $scope.library.customRobuxFilterId) {
                // only allow input that is less than or equal to 9 chars long
                $scope.data.minPrice = $scope.data.minPrice && $scope.data.minPrice.toString().length > 9 ? null : $scope.data.minPrice;
                $scope.data.maxPrice = $scope.data.maxPrice && $scope.data.maxPrice.toString().length > 9 ? null : $scope.data.maxPrice;
                var min = $scope.data.minPrice;
                var max = $scope.data.maxPrice;

                // if the supplied min is greater than the supplied max, reverse them
                if (max && min > max) {
                    $scope.data.minPrice = max;
                    $scope.data.maxPrice = min;
                }

                $scope.data.minPriceBreadcrumb = $scope.data.minPrice || 0;
                $scope.data.maxPriceBreadcrumb = $scope.data.maxPrice;

                if ($scope.data.minPrice === null && $scope.data.maxPrice === null) {
                    params.pxMin = 0;
                    params.pxMax = 0;
                } else {
                    params.pxMin = $scope.data.minPrice;
                    params.pxMax = $scope.data.maxPrice;

                }
            }

            if (currencyType.currencyType === $scope.library.freeFilterId) {
                params.pxMin = 0;
                params.pxMax = 0;
            }
        }
    }

    $scope.setSelectedNavigationMenu = function (category, subcategory, gears, catalogContext) {
        if (!$scope.navigationMenu.categories) {
            return false;
        }

        if (!category) {
            // If a catalog context is provided, set the category to All instead of Featured
            category = catalogContext ? $scope.library.allCategoriesId : $scope.library.defaultCategoryId;
        }

        var categoryOption = $scope.navigationMenu.categories.find(function (cat) {
            return cat.categoryId === category;
        });

        $scope.currentQuery.category = categoryOption;

        if (!categoryOption || (categoryOption.subcategories && categoryOption.subcategories.length === 0)) {
            $scope.currentQuery.subcategory = null;
            return false;
        }

        if (category === $scope.library.gearCategoryId) {
            var gear = gears ? gears[0] : null;
            if (!gear) {
                gear = categoryOption.subcategories[0].subcategoryId; // set to first item as default
            }

            // set subcategory to the gear attribute that is selected since we know the category is "Gear" 
            $scope.currentQuery.subcategory = categoryOption.subcategories.find(function (subcat) {
                return subcat.subcategoryId === gear;
            });
        } else {
            // if no subcategory is defined then set it to the first item from the category submenu
            if (subcategory) {
                $scope.currentQuery.subcategory = categoryOption.subcategories.find(function (subcat) {
                    return subcat.subcategoryId === subcategory;
                });
            }
        }

        return false;
    }

    $scope.setCreatorFilters = function (creatorFilters) {
        if (!creatorFilters) {
            $scope.data.creators = null;
            $scope.data.displayCreators = false;
            return false;
        }

        // if All Users and ROBLOX are the only options, we need to add a custom option
        var indexOfCustomFilter = 2;
        if (creatorFilters.length === indexOfCustomFilter) {
            creatorFilters.push({
                name: null,
                isSelected: false,
                userId: $scope.layout.customText
            });
            // set Data of custom username option to "custom" 
        } else if (creatorFilters.length > indexOfCustomFilter && creatorFilters[indexOfCustomFilter]) {
            var customCreatorFilter = creatorFilters[indexOfCustomFilter];
            customCreatorFilter.userId = $scope.layout.customText;
            $scope.data.creatorName = customCreatorFilter.name;
        }

        $scope.data.creators = creatorFilters;
        return true;
    }

    $scope.setGenresInMenuOptions = function (selectedGenres) {
        if (!$scope.navigationMenu.genres) {
            return;
        }

        // genreArray will be a string array containing all genres from the request
        var genreArray = [];
        if (selectedGenres) {
            if (!Array.isArray(selectedGenres)) {
                genreArray.push(parseInt(selectedGenres));
            } else {
                for (var i = 0; i < selectedGenres.length; i++) {
                    genreArray.push(parseInt(selectedGenres[i]));
                }
            }
        }

        const { genres } = $scope.navigationMenu; 
        // set selected genres
        for (var j = 0; j < genres.length; j++) {
            const genreOption = genres[j];
            genres[j].isSelected = genreArray.indexOf(genreOption.genre) >= 0;
        }
    }
    $scope.setGenres = function (genres) {
        if (!$scope.data.genres) {
            return;
        }

        // genreArray will be a string array containing all genres from the request
        var genreArray = [];
        if (genres) {
            if (!Array.isArray(genres)) {
                genreArray.push(genres.toString());
            } else {
                for (var i = 0; i < genres.length; i++) {
                    genreArray.push(genres[i].toString());
                }
            }
        }

        // set selected genres
        for (var j = 0; j < $scope.data.genres.length; j++) {
            var genreOption = $scope.data.genres[j];
            $scope.data.genres[j].IsSelected = genreArray.indexOf(genreOption.genre) >= 0;
        }
    }

    $scope.setCreatorValue = function (creatorId, creatorName, creatorType) {
        var creatorFilters = $scope.data.creators;

        if (creatorName) {
            $scope.data.creator = creatorFilters.find(function (creator) {
                return creator.userId === $scope.layout.customText;
            });
            $scope.data.creatorName = creatorName;
            $scope.data.creatorBreadcrumb = creatorName;
        } else {
            if (!creatorId) {
                creatorId = $scope.library.defaultCreatorId;
            }

            var creatorIdInt = parseInt(creatorId);
            if (creatorIdInt > parseInt($scope.library.robloxUserId)) {
                $scope.data.creator = creatorFilters.find(function (creator) {
                    return creator.userId === $scope.layout.customText;
                });

                $scope.data.creator.userId = creatorIdInt;
            } else {
                $scope.data.creator = creatorFilters.find(function (creator) {
                    return creator.userId === creatorId;
                });
            }

            $scope.data.creatorBreadcrumb = $scope.data.creator && $scope.data.creator.userId !== $scope.library.defaultCreatorId ? $scope.data.creator.name : null;
            $scope.data.creatorName = null;
        }

        if ($scope.data.creator && creatorType) {
            $scope.data.creator.type = creatorType;
        }
    };

    $scope.setCurrencyValue = function (currencyType, minPrice, maxPrice) {
        var currencyTypes = $scope.navigationMenu.currencyTypes;
        if (!currencyTypes) {
            $scope.data.currencyType = null;
            return false;
        }

        if (currencyType == null) {
            $scope.data.currencyType = $scope.library.defaultCurrencyType;
        } else {
            $scope.data.currencyType = currencyTypes.find(function (currency) {
                return currency.currencyType === currencyType;
            });
        }

        $scope.data.showFreeBreadcrumb = $scope.data.currencyType && $scope.data.currencyType.currencyType === $scope.library.freeFilterId;
        $scope.data.minPrice = null;
        $scope.data.maxPrice = null;

        if ($scope.data.currencyType.currencyType === $scope.library.customRobuxFilterId) {
            minPrice = minPrice ? parseInt(minPrice) : null;
            maxPrice = maxPrice ? parseInt(maxPrice) : null;
            $scope.data.minPrice = minPrice !== 0 ? minPrice : null;
            $scope.data.maxPrice = maxPrice !== 0 ? maxPrice : null;
            $scope.data.minPriceBreadcrumb = minPrice || 0;
            $scope.data.maxPriceBreadcrumb = maxPrice;
        }

        return false;
    }

    $scope.setSortMenus = function (sortType, sortAggregation) {
        const { sortMenus } = $scope.navigationMenu;
        if (!sortMenus) {
            $scope.data.sortType = null;
            $scope.data.sortAggregation = null;
            return false;
        }
        const { sortOptions, sortAggregations } = sortMenus;
        if (sortOptions) {
            $scope.data.defaultSortValue = sortOptions[0];
            if (sortType == null) {
                $scope.data.sortType = $scope.data.defaultSortValue;
            } else {
                $scope.data.sortType = sortOptions.find(function (sort) {
                    return sort.sortType === sortType;
                });
            }
        } else {
            $scope.data.sortType = null;
        }
        if (sortAggregations) {
            $scope.data.defaultSortAggregationValue = sortAggregations[0];
            if (sortAggregation == null) {
                $scope.data.sortAggregation = $scope.data.defaultSortAggregationValue;
            } else {
                $scope.data.sortAggregation = sortAggregations.find(function (sort) {
                    return sort.sortAggregation === sortAggregation;
                });
            }

        } else {
            $scope.data.sortAggregation = null;
        }
        return false;
    }

    $scope.setSortType = function (sortType) {
        var sortMenus = $scope.data.sortMenus;
        if (!sortMenus || !sortMenus[0]) {
            $scope.data.sortType = null;
            return false;
        }

        if (sortMenus[0].Sorts) {
            $scope.data.defaultSortValue = sortMenus[0].Sorts[0];
            if (sortType == null) {
                $scope.data.sortType = $scope.data.defaultSortValue;
            } else {
                $scope.data.sortType = sortMenus[0].Sorts.find(function (sort) {
                    return sort.sortType === sortType;
                });
            }
        }
        return false;
    }

    $scope.setSortAggregation = function (sortAggregation) {
        var sortMenus = $scope.data.sortMenus;
        if (!sortMenus || !sortMenus[1]) {
            $scope.data.sortAggregation = null;
            return false;
        }

        if (sortMenus[1].Sorts) {
            $scope.data.defaultSortAggregationValue = sortMenus[1].Sorts[0];
            if (sortAggregation == null) {
                $scope.data.sortAggregation = $scope.data.defaultSortAggregationValue;
            } else {
                $scope.data.sortAggregation = sortMenus[1].Sorts.find(function (sort) {
                    return sort.sortAggregation === sortAggregation;
                });
            }
        }

        return false;
    }

    $scope.getCategoryMenu = function (category) {
        if (!category) {
            return null;
        }

        return $scope.navigationMenu.categories.find(function (c) {
            return c.categoryId === category.categoryId;
        });
    }

    $scope.getCategoryOption = function (category) {
        return $scope.getCategoryMenu(category);
    }

    $scope.getCategoryDropdownValue = function () {
        if (!$scope.currentQuery.category) {
            return "";
        }

        // For Gear, update the category dropdown in the search bar to be the Gear genre
        if ($scope.currentQuery.category.categoryId === $scope.library.gearCategoryId
            && $scope.currentQuery.subcategory
            && $scope.currentQuery.subcategory.subcategoryId !== $scope.library.defaultGearSubcategoryId) {
            return $scope.currentQuery.subcategory.name;
        }

        return $scope.currentQuery.category.name;
    }

    $scope.updateCategory = function (event, clearFilters, clearKeyword, category, subcategory) {
        if (clearKeyword) {
            $scope.searchLayout.keyword = null;
        }

        if (subcategory) {
            event.stopPropagation();
        }

        $scope.currentQuery.category = category;
        $scope.currentQuery.subcategory = subcategory;

        // if no subcategory was supplied, set the subcategory to the default for the given category
        if (!subcategory) {
            var cat = $scope.getCategoryOption(category);
            if (cat && cat.subcategories) {
                $scope.currentQuery.subcategory = cat.subcategories[0];
            }
        }

        $scope.library.isSplashPage = false;

        if (clearFilters) {
            $scope.$broadcast(catalogConstants.clearFiltersEvent, { keepKeyword: !clearKeyword });
        } else {
            $scope.applySearch(true);
        }
    }

    $scope.updateSort = function (sort) {
        $scope.data.sortType = sort;
        $scope.applySearch(true);
    }

    $scope.updateSortAggregation = function (sortAggregation) {
        $scope.data.sortAggregation = sortAggregation;
        $scope.applySearch(true);
    }

    $scope.filterChanged = function () {
        if ($scope.layout.isSearchOptionsOpen) {
            return;
        }

        // Don't apply new search if user selects custom username or custom price range
        // because those require input before applying

        // if selecting custom creator filter and one is not already applied, don't apply new search
        if (!$scope.data.customCreatorSelected
            && !$scope.data.creatorName
            && $scope.data.creator
            && $scope.data.creator.userId === $scope.layout.customText) {
            $scope.data.customCreatorSelected = true;
            return;
        } else {
            $scope.data.isCreatorAGroup = false;
            $scope.data.customCreatorSelected = false;
        }

        // If selecting custom price filter and one is not already applied
        if ($scope.data.minPriceBreadcrumb == null
            && $scope.data.currencyType
            && $scope.data.currencyType.currencyType === $scope.library.customRobuxFilterId) {
            // if custom price was not previously selected but now it is, don't apply new search
            if (!$scope.data.customPriceSelected) {
                $scope.data.customPriceSelected = true;
                return;
            } else {
                // otherwise change the price filter to the default
                $scope.data.currencyType = $scope.data.defaultCurrencyValue;
                $scope.data.customPriceSelected = false;
            }
        } else {
            $scope.data.customPriceSelected = false;
        }

        $scope.applySearch(true);
    }

    $scope.applySearch = function (fadeResultsWhileLoading, rememberPage) {
        $scope.layout.isSearchItemsLoaded = false;
        $scope.library.isSplashPage = false;
        $scope.setQuery(rememberPage);
        $scope.getPagedItems(true, fadeResultsWhileLoading);
        $scope.adRefresh();
    };

    $scope.applyCreatorName = function () {
        $scope.applySearch();
    };

    $scope.mobileCategoryClick = function (category, forceUpdate) {
        const { subcategories } = category;
        if (!category || (!forceUpdate && subcategories && subcategories.length > 0)) {
            return;
        }

        if (!subcategories || subcategories.length === 0) {
            $scope.currentQuery.subcategory = null;
        }

        $scope.currentQuery.category = category;
    }

    $scope.clearGenreFilters = function () {
        if ($scope.library.isNavigationMenuOptionsFromApiEnabled) {
            $scope.navigationMenu.genres.forEach(function (genre) {
                genre.isSelected = false;
            });
        } else {
            $scope.data.genres.forEach(function (genre) {
                genre.IsSelected = false;
            });
        }

        $scope.applySearch(true);
    }

    $scope.getAllFeaturedItems = function () {
        var params = { Category: $scope.library.defaultCategoryId };
        $scope.library.isSplashPage = false;
        $scope.data.query = params;
        $scope.queries = utilityService.formatQueries(params);
        $location.search(params);
        $scope.getPagedItems(true, false);
    }

    $scope.showViewAllFeaturedItemsButton = function () {
        const { isSplashPage, initialized, isPhone } = $scope.library;
        return !$scope.data.isCatalogInfiniteScrollEnabled && isSplashPage && initialized && !isPhone;
    }

    $scope.showUnavailableFilter = function () {
        return $scope.library && !$scope.library.isPhone;
    }

    $scope.showCurrencyType = function (currencyType) {
        if (!$scope.currentQuery.category || !currencyType) {
            return false;
        }

        // hide free filter when the category is set to default
        return !($scope.currentQuery.category.categoryId === $scope.library.defaultCategoryId
            && currencyType.currencyType === $scope.library.freeFilterId);
    }

    $scope.categoryClick = function (event, category) {
        // prevent accordion menu collapse if the clicked category is currently selected  
        if (!category
            || (($scope.currentQuery.category && category.categoryId === $scope.currentQuery.category.categoryId )
                && !$scope.searchLayout.keyword)) { // make sure if category click is the same current category selected but without any keyword filled from search
            event.stopPropagation();
            return;
        }

        // for categories that don't have a subcategory menu, apply new search
        if (!category.subcategories || category.subcategories.length === 0) {
            $scope.library.isSplashPage = false;
            $scope.currentQuery.category = category;
            $scope.currentQuery.subcategory = null;
            $scope.$broadcast(catalogConstants.clearFiltersEvent);
        }
    }

    $scope.expandSelectedCategoryMenu = function () {
        var selectedCategory = $scope.currentQuery.category;

        if (!selectedCategory) {
            return;
        }

        var selectedCategoryDataValue = selectedCategory.categoryId;
        BootstrapWidgets.ShowAccordionMenu($scope.layout.accordionMenuIdPrefix + selectedCategoryDataValue);
    }

    var watchCurrencyTypeInitialized = $scope.$watch('data.currencyType',
        function (newValue) {
            if (newValue && newValue.excludePriceSorts
                && $scope.data.sortType && $scope.data.sortType.isPriceRelated) {
                $scope.data.sortType = $scope.data.defaultSortValue;
            }
        });

    var watchCategoryInitialized = $scope.$watch('data.category',
        function (newValue) {
            if (newValue) {
                $scope.data.displayCreators = $scope.library.categoriesWithCreatorFilters.includes(newValue.categoryId);

                // Set currency filter to default if new category is the default and the current currency filter is Free
                if (newValue.categoryId === $scope.library.defaultCategoryId
                    && $scope.data.currencyType && $scope.data.currencyType.currencyType === $scope.library.freeFilterId) {
                    $scope.data.currencyType = $scope.library.defaultCurrencyType;
                    $scope.data.showFreeBreadcrumb = false;
                    $scope.$apply();
                }
            }
        });

    $scope.$on("$destroy", function () {
        if (watchCurrencyTypeInitialized) {
            watchCurrencyTypeInitialized();
        }

        if (watchCategoryInitialized) {
            watchCategoryInitialized();
        }
    });

    $scope.initialize();
}

catalogModule.controller("catalogController", catalogController);

export default catalogController;